<template>
  <div class="inequality-metrics">
    <!-- <img alt="Inequality Metrics" src="../assets/sp2lnob/Inequality_Metrics.png" /> -->
    <data-table
      :chart-options="tableOptions"
      :data="dataObjectStr">
      </data-table>
  </div>
</template>

<script>
import DataTable from '@wc/data-table/data-table.vue';
export default {
  name: 'Inequality Metrics',
  components: { DataTable },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      dataObj: {
        columns: [
          // {
          //   name: 'Category',
          //   type: 'string'
          // },
          // {
          //   name: 'National Average',
          //   type: 'string'
          // },
          // {
          //   name: 'Gini',
          //   type: 'string'
          // },
          // {
          //   name: 'Theil',
          //   type: 'string'
          // },
          // {
          //   name: 'Atkinson',
          //   type: 'string'
          // }
        ],
        data: [
          // ['Current', '0.50', '0.16', '0.07', '0.03'],
          // ['Simulated', '0.50', '0.16', '0.07', '0.03']
        ]
      },
      dataObjectStr: '{"data":[],"colums":[]}',
      tableOptions: {
        allowSearch: false,
        paging: false,
        csvDownload: true
      }
    };
  },
  mounted () {
    this.getTableData();
  },
  watch: {
    data: {
      handler: function (data) {
        const newTbData = {
          data: [],
          columns: []
        };
        if (data.length > 0) {
          for (const d of data) {
            delete d._row;
            const rowData = Object.values(d);
            if (rowData[0] === 'Current') {
              rowData[0] = 'Without social protection';
            } else if (rowData[0] === 'Simulated') {
              rowData[0] = 'With social protection';
            }
            newTbData.data.push(rowData);
          }
          for (const key of Object.keys(data[0])) {
            newTbData.columns.push({ name: key.charAt(0).toUpperCase() + key.slice(1), type: 'string' });
          }
          // console.log(JSON.stringify(newTbData));
          this.dataObjectStr = JSON.stringify(newTbData);
        }
      }
    }
  },
  methods: {
    getTableData: function () {
      this.dataObjectStr = JSON.stringify(this.dataObj);
    }
  }
};
</script>

<style lang="css">
.inequality-metrics img {
  width: 100%;
}
.inequality-metrics div.dt-buttons {
  float: right;
  font-family: Inter;
  font-size: 14px;
}
.inequality-metrics table.dataTable td, .inequality-metrics table.dataTable th {
    font-size: 16px;
    font-family: Roboto;
    line-height: normal;
}
</style>
